/**
 * Fine Wines Health — Collection page filtering & sorting
 * v2 — search + category match across title, description, type, tags via data-search
 */
(function() {
  'use strict';
  var searchEl = document.getElementById('collection-search');
  var categoryCheckboxes = document.querySelectorAll('input[name="collection-category"]');
  var priceEl = document.getElementById('collection-price');
  var tagBtns = document.querySelectorAll('.collection-filter-tag');
  var clearBtn = document.getElementById('collection-clear');
  var gridEl = document.getElementById('collection-grid');
  var noResultsEl = document.getElementById('collection-no-results');
  var countEl = document.getElementById('collection-count');
  var sortEl = document.getElementById('collection-sort');
  var cards = gridEl ? Array.from(gridEl.querySelectorAll('.collection-card')) : [];
  var activeTag = null;

  // Category → keyword set. We match against each card's data-search (title + description + type + tags).
  // Add/edit keywords here to broaden a category's reach.
  var CATEGORY_KEYWORDS = {
    'sleep':   ['sleep','night','rest','melatonin','midnight','restore','insomnia','calm'],
    'skin':    ['skin','glow','collagen','radiance','elixir','beauty','anti-aging','complexion','wrinkle'],
    'hormone': ['hormone','menopause','perimenopause','harmony','foundation','estrogen','estradiol','progesterone','testosterone','perimeno'],
    'mood':    ['mood','memory','focus','brain','neuro','cognitive','clarity','mental','adaptogen'],
    'vaginal': ['vaginal','sexual','libido','scream','intimate','pt-141','arousal','dryness','sex'],
    'bone':    ['bone','joint','calcium','k2','d3','architect','cardio','heart']
  };

  function getSelectedCategories() {
    var sel = [];
    categoryCheckboxes.forEach(function(cb) { if (cb.checked) sel.push(cb.value); });
    return sel;
  }

  function getPriceRange(val) {
    if (!val) return null;
    var parts = val.split('-');
    return { min: parseFloat(parts[0]), max: parseFloat(parts[1]) };
  }

  function categoryHit(searchText, selectedCats) {
    if (!selectedCats.length) return true;
    return selectedCats.some(function(cat) {
      var kws = CATEGORY_KEYWORDS[cat] || [cat];
      return kws.some(function(kw) { return searchText.indexOf(kw) !== -1; });
    });
  }

  function matchesFilters(card) {
    var search = (searchEl && searchEl.value || '').trim().toLowerCase();
    var selectedCats = getSelectedCategories();
    var priceRange = getPriceRange(priceEl && priceEl.value);
    var price = parseFloat(card.getAttribute('data-price')) || 0;
    var cardTags = (card.getAttribute('data-tags') || '').toLowerCase().split(/\s+/).filter(Boolean);
    var dataSearch = (card.getAttribute('data-search') || '').toLowerCase();

    // Free-text search across title + description + type + tags
    if (search && dataSearch.indexOf(search) === -1) return false;
    // Category match by keyword presence in dataSearch
    if (!categoryHit(dataSearch, selectedCats)) return false;
    // Price range
    if (priceRange && (price < priceRange.min || price > priceRange.max)) return false;
    // Tag pill (single-select)
    if (activeTag && cardTags.indexOf(activeTag) === -1) return false;
    return true;
  }

  function applyFilters() {
    var visible = 0;
    cards.forEach(function(card) {
      var show = matchesFilters(card);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    if (noResultsEl) {
      noResultsEl.style.display = visible === 0 ? 'block' : 'none';
      noResultsEl.classList.toggle('visible', visible === 0);
    }
    if (countEl) countEl.textContent = 'Showing 1 to ' + visible + ' of ' + cards.length;
  }

  function clearFilters() {
    if (searchEl) searchEl.value = '';
    categoryCheckboxes.forEach(function(cb) { cb.checked = false; });
    if (priceEl) priceEl.value = '';
    activeTag = null;
    tagBtns.forEach(function(btn) { btn.classList.remove('active'); });
    applyFilters();
  }

  function doSort() {
    var val = sortEl ? sortEl.value : 'default';
    var heading = gridEl ? gridEl.querySelector('.collection-bundle-heading') : null;
    if (heading && heading.parentNode === gridEl) {
      gridEl.removeChild(heading);
    }
    cards.sort(function(a, b) {
      var pa = parseFloat(a.getAttribute('data-price')) || 0;
      var pb = parseFloat(b.getAttribute('data-price')) || 0;
      var ta = (a.querySelector('.collection-card-title') || {}).textContent || '';
      var tb = (b.querySelector('.collection-card-title') || {}).textContent || '';
      if (val === 'price-low') return pa - pb;
      if (val === 'price-high') return pb - pa;
      if (val === 'name') return ta.localeCompare(tb);
      if (val === 'default') {
        var ba = parseInt(a.getAttribute('data-is-bundle') || '0', 10) || 0;
        var bb = parseInt(b.getAttribute('data-is-bundle') || '0', 10) || 0;
        if (ba !== bb) return ba - bb;
      }
      return 0;
    });
    if (gridEl) {
      cards.forEach(function(c) {
        gridEl.appendChild(c);
      });
      if (heading) {
        if (val === 'default') {
          var firstB = null;
          for (var i = 0; i < cards.length; i++) {
            if (cards[i].getAttribute('data-is-bundle') === '1') {
              firstB = cards[i];
              break;
            }
          }
          if (firstB) gridEl.insertBefore(heading, firstB);
          else gridEl.insertBefore(heading, gridEl.firstChild);
          heading.style.display = '';
        } else {
          gridEl.appendChild(heading);
          heading.style.display = 'none';
        }
      }
    }
  }

  var filterToggle = document.getElementById('collection-filter-toggle');
  var sidebarEl = document.querySelector('.collection-sidebar');
  if (filterToggle && sidebarEl) {
    filterToggle.addEventListener('click', function() {
      sidebarEl.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', sidebarEl.classList.contains('open'));
    });
  }
  if (clearBtn) clearBtn.addEventListener('click', clearFilters);
  if (searchEl) searchEl.addEventListener('input', applyFilters);
  categoryCheckboxes.forEach(function(cb) { cb.addEventListener('change', applyFilters); });
  if (priceEl) priceEl.addEventListener('change', applyFilters);
  if (sortEl) sortEl.addEventListener('change', function() { doSort(); applyFilters(); });
  tagBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tag = this.getAttribute('data-tag');
      if (activeTag === tag) { activeTag = null; this.classList.remove('active'); }
      else { tagBtns.forEach(function(b) { b.classList.remove('active'); }); activeTag = tag; this.classList.add('active'); }
      applyFilters();
    });
  });
  applyFilters();
})();
